import { withChartLayout } from 'components/common';
import AnnualAmbulatoryCare from 'components/features/chart/special-charts/annual-ambulatory-care/AnnualAmbulatoryCare';

const AnnualAmbulatoryCarePage = withChartLayout('Annual Ambulatory Care')(AnnualAmbulatoryCare);
export default AnnualAmbulatoryCarePage;
